import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { QivosCloudService } from '@qivos/qivoscloud-ng-api';
import { catchError, of, switchMap } from 'rxjs';
import {
  AuthByToken,
  AuthByTokenFailed,
  AuthByTokenSuccess,
  InitMobileNumber,
  InitQCCode,
  RedirectToAddToWalletPageFailed,
  RedirectToAddToWalletPageSuccess,
  searchPersonByTelephone,
  searchPersonByTelephoneFail,
  searchPersonByTelephoneSuccess,
  UpdatePersonData,
  UpdatePersonDataFailed,
  UpdatePersonDataSuccess,
} from '../actions/ms-registration-form.actions';
import { MSService } from '../services/ms.service';

@Injectable()
export class MsRegistrationFormEffects {
  constructor(
    private actions$: Actions,
    public qcService: QivosCloudService,
    public msService: MSService
  ) {}

  authByToken$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthByToken),
      switchMap(({ token }) =>
        this.qcService.authByToken(token).pipe(
          switchMap((response: any) => of(AuthByTokenSuccess(response))),
          catchError((error) => of(AuthByTokenFailed(error)))
        )
      )
    )
  );

  searchAfterTokenSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthByTokenSuccess),
      switchMap(() => {
        const person = this.qcService.getDecodedToken();
        if (person !== null) {
          return of(
            InitMobileNumber({ mobileNumber: person.mobileNumber }),
            searchPersonByTelephone({ mobileNumber: person.mobileNumber }),
            InitQCCode({ qcCode: person.personQCCode })
          );
        } else {
          return of();
        }
      })
    )
  );

  authByMobileNumber$ = createEffect(() =>
    this.actions$.pipe(
      ofType(searchPersonByTelephone),
      switchMap(({ mobileNumber }) =>
        this.qcService.searchPersonByTelephone(mobileNumber).pipe(
          switchMap((res) =>
            of(searchPersonByTelephoneSuccess({ persons: res?.payload.data }))
          ),
          catchError((error) => of(searchPersonByTelephoneFail(error)))
        )
      )
    )
  );

  updatePersonData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UpdatePersonData),
      switchMap(({ person }) =>
        this.qcService.updatePerson(person).pipe(
          switchMap((response: any) =>
            of(UpdatePersonDataSuccess({ response }))
          ),
          catchError((error) => of(UpdatePersonDataFailed(error)))
        )
      )
    )
  );

  redirect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UpdatePersonDataSuccess),
      switchMap(() => {
        this.msService.redirect();
        return of(RedirectToAddToWalletPageSuccess());
      }),
      catchError((error) => of(RedirectToAddToWalletPageFailed(error)))
    )
  );
}
